import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPhoneLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6.869 5c-.283 0-.601.11-.962.465l-.016.014c-.323.306-.54.632-.675.975l-.003.005a3.1 3.1 0 0 0-.216 1.173c0 .676.156 1.415.497 2.226.35.823.837 1.67 1.457 2.532q.947 1.301 2.13 2.495a22 22 0 0 0 2.505 2.14 13 13 0 0 0 2.555 1.471c.82.35 1.558.504 2.216.504.433 0 .822-.08 1.175-.227l.006-.002a2.6 2.6 0 0 0 .95-.691c.162-.179.285-.367.38-.571.075-.157.105-.307.105-.445a.6.6 0 0 0-.048-.23.3.3 0 0 0-.09-.084l-.009-.006-2.64-1.874a2 2 0 0 0-.368-.208.5.5 0 0 0-.109-.03h-.005q0-.002-.043.022l-.057.033a1.5 1.5 0 0 0-.332.268l-.005.005-.606.598a1.44 1.44 0 0 1-1.032.426 1.6 1.6 0 0 1-.594-.113l-.095-.042-.006-.003-.023-.01q-.006-.003.003 0a1 1 0 0 1-.097-.044c-.36-.19-.764-.48-1.21-.857h-.001c-.45-.383-.885-.793-1.325-1.225l-.014-.014a28 28 0 0 1-1.202-1.31l-.007-.008c-.37-.437-.668-.84-.859-1.191a1 1 0 0 1-.066-.15l-.006-.013-.003-.007-.047-.118a1.724 1.724 0 0 1-.088-.535c0-.367.127-.729.412-1.018l.603-.627.014-.014a1.8 1.8 0 0 0 .3-.381.2.2 0 0 0 .022-.044v-.003l-.002-.013a1 1 0 0 0-.028-.082l-.007-.015a1.8 1.8 0 0 0-.206-.355l-.004-.005L7.231 5.16a.3.3 0 0 0-.133-.109l-.014-.006A.5.5 0 0 0 6.87 5m-2.358-.968C5.173 3.384 5.971 3 6.87 3c.362 0 .732.077 1.074.24.352.163.677.416.928.777l1.852 2.61q.267.369.428.755c.11.257.19.558.19.874 0 .388-.113.752-.305 1.074-.158.274-.366.53-.597.762l-.338.351c.111.162.268.368.48.619.347.4.713.805 1.107 1.207.421.413.816.784 1.212 1.12.252.214.46.37.626.479l.334-.33c.232-.231.495-.45.79-.61a2.06 2.06 0 0 1 1.059-.296c.299 0 .587.064.867.178.26.107.506.25.743.411l.017.012 2.644 1.877a2.2 2.2 0 0 1 .793.959c.117.291.2.618.2.995 0 .438-.098.88-.296 1.299a4.3 4.3 0 0 1-.707 1.06 4.6 4.6 0 0 1-1.671 1.197 5 5 0 0 1-1.942.38c-.974 0-1.98-.23-3-.664a15 15 0 0 1-2.949-1.696 24 24 0 0 1-2.739-2.338l-.007-.006a24 24 0 0 1-2.33-2.731l-.003-.005c-.691-.961-1.259-1.937-1.676-2.921l-.002-.003c-.426-1.012-.654-2.016-.654-3.004 0-.662.117-1.308.358-1.913a4.7 4.7 0 0 1 1.156-1.687'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPhoneLine)
export default ForwardRef
